import { addDiasCorridos, addDiasUteis, parseNumero } from "./calculos";
import { hasValue, isYes } from "./data";
import { F } from "./gerencialFields";
import { buildDeadlineStatus, toDate } from "./status";

export function isLiberacaoAmbientePending(row) {
  return isYes(row[F.OBRA_FUTURA]) && !hasValue(row[F.LIBERACAO_DA_OBRA]);
}

export function calculateLiberacaoTimeline({ referenceDate = new Date(), prazoEmDias } = {}) {
  const prazo = parseNumero(prazoEmDias);
  const medicao = addDiasUteis(referenceDate, 10);
  const executivo = addDiasUteis(medicao, 10);

  if (!executivo || prazo === null) {
    return {
      medicao,
      executivo,
      conclusaoProducao: null,
      entregaSugerida: null,
    };
  }

  const conclusaoProducao = addDiasCorridos(executivo, prazo);
  const entregaSugerida = addDiasUteis(conclusaoProducao, 10);

  return {
    medicao,
    executivo,
    conclusaoProducao,
    entregaSugerida,
  };
}

export function buildLiberacaoStatus(row, referenceDate = new Date()) {
  const entregaContrato = toDate(row[F.ENTREGA_PREVISTA]);
  const prazo = parseNumero(row[F.PRAZO_EM_DIAS]);
  const statusBase = buildDeadlineStatus(entregaContrato, { referenceDate });

  if (!entregaContrato || prazo === null) {
    return {
      sugestaoEntrega: null,
      sugestaoOrdenacao: null,
      ...statusBase,
    };
  }

  const { entregaSugerida } = calculateLiberacaoTimeline({
    referenceDate,
    prazoEmDias: prazo,
  });

  if (!entregaSugerida) {
    return {
      sugestaoEntrega: null,
      sugestaoOrdenacao: null,
      ...statusBase,
    };
  }

  const atrasado = entregaSugerida.getTime() > entregaContrato.getTime();

  return {
    sugestaoEntrega: atrasado ? entregaSugerida : null,
    sugestaoOrdenacao: entregaSugerida,
    ...(atrasado ? { status: "Vencido", statusVariant: "danger" } : statusBase),
  };
}
